<template>
  <div v-if="user.is_generate_facture">
    <v-btn
      color="color_action"
      absolute
      top
      fixed
      right
      class="mt-14"
      @click="openDialog()"
    >
      <v-icon left> mdi-feather </v-icon>
      {{ $t("btn.facture") }}
    </v-btn>
    <v-dialog v-model="dialog" persistent>
      <v-card flat class="white">
        <rob-description />
        <v-card-actions class="white">
          <v-spacer />
          <v-btn color="color_action" @click="closeDialog()">
            <v-icon left dark> mdi-close </v-icon>
            {{ $t("btn.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { generalMixin } from "@/mixins/general";
import { userMixin } from "@/mixins/user";
import RobDescription from "@/components/RobDescription";
import { robMixin } from "@/mixins/rob";

export default {
  name: "VueDialogueFacture",
  components: {
    RobDescription,
  },
  mixins: [generalMixin, userMixin, robMixin],
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    openDialog() {
      this.getRob(this.paramsRob.robId);
      this.dialog = true;
    },
    closeDialog() {
      {
        this.dialog = false;
      }
    },
  },
};
</script>

<style scoped></style>
